import { styled } from '@mui/material';

import { Delete } from '@mui/icons-material';

const DeleteButton = styled(Delete)(({ theme }) => ({
    color: theme.palette.error['main'],
    borderRadius: '50%',
    padding: '4px',
    cursor: 'pointer',
    fontSize: '30px',
    ':hover': {
        backgroundColor: '#ffdede',
    },
}));

export default DeleteButton;
